import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import axios from 'axios';
import qs from 'qs';

Vue.use(VueAwesomeSwiper);
Vue.use(ElementUI);
import App from './App.vue';
import router from './router/';

Vue.config.productionTip = false;

Vue.prototype.$axios = axios;
Vue.prototype.qs = qs;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
